var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconNavFuelUsage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.102,
    height: 29.733,
    viewBox: "0 0 35.102 29.733",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #022859;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_nav_fuel_usage",
    transform: "translate(0.051 0.051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_521",
    "data-name": "Path 521",
    className: "cls-1",
    d: "M965.638,297.43l-1.3,1.3a15.551,15.551,0,0,1,4.321,10.438h1.84a17.372,17.372,0,0,0-4.861-11.739Z",
    transform: "translate(-935.499 -292.041)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_522",
    "data-name": "Path 522",
    className: "cls-1",
    d: "M39.57,309.144a15.551,15.551,0,0,1,4.321-10.438l-1.3-1.3a17.378,17.378,0,0,0-4.86,11.739Z",
    transform: "translate(-37.731 -292.017)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_523",
    "data-name": "Path 523",
    className: "cls-1",
    d: "M612,126.134a15.548,15.548,0,0,1,10.437,4.322l1.3-1.3A17.373,17.373,0,0,0,612,124.295Z",
    transform: "translate(-594.126 -124.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_524",
    "data-name": "Path 524",
    className: "cls-1",
    d: "M43.89,708.984a15.547,15.547,0,0,1-4.321-10.437H37.73a17.4,17.4,0,0,0,4.861,11.737Z",
    transform: "translate(-37.73 -680.673)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_525",
    "data-name": "Path 525",
    className: "cls-1",
    d: "M970.508,698.57h-1.84a15.55,15.55,0,0,1-4.321,10.437l1.3,1.3a17.4,17.4,0,0,0,4.861-11.737Z",
    transform: "translate(-935.507 -680.697)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_526",
    "data-name": "Path 526",
    className: "cls-1",
    d: "M210.84,129.155l1.3,1.3a15.554,15.554,0,0,1,10.438-4.322v-1.839a17.375,17.375,0,0,0-11.739,4.861Z",
    transform: "translate(-205.453 -124.295)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_527",
    "data-name": "Path 527",
    className: "cls-1",
    d: "M497.919,543.79c-.9,1.882-3.279,7.062-3.279,8.9,0,2.155,1.471,3.907,3.279,3.907s3.279-1.752,3.279-3.907C501.2,550.851,498.815,545.672,497.919,543.79Z",
    transform: "translate(-480.419 -530.734)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNavFuelUsage);
export default __webpack_public_path__ + "static/media/Icon_nav_fuel_usage.9bc37fc186cc0e3ba222b446e800a00c.svg";
export { ForwardRef as ReactComponent };